export const ACTIVITY_STATUS = [
  { id: 1, name: "Pending" },
  { id: 2, name: "Completed" },
  { id: 3, name: "Missed" },
  { id: 4, name: "Canceled" },
  { id: 5, name: "ReScheduled" },
  { id: 6, name: "Overdue" },
];

/**
 * Normalizes activity status across different API payload structures (StatusId vs statusId, StatusName vs statusName vs status)
 * and dynamically calculates Overdue status for past pending activities.
 */
export const getNormalizedActivityStatus = (item) => {
  if (!item) return { id: 1, name: "Pending" };

  let statusId = item.StatusId ?? item.statusId ?? item.status_id ?? item._raw?.StatusId ?? item._raw?.statusId;
  let statusName = item.StatusName || item.statusName || item.status || item.Status || item._raw?.StatusName || item._raw?.statusName || item._raw?.status;

  if (typeof statusId !== "undefined" && statusId !== null && statusId !== "") {
    const numId = Number(statusId);
    if (!isNaN(numId) && numId > 0) {
      statusId = numId;
      const found = ACTIVITY_STATUS.find(s => s.id === numId);
      if (found) {
        statusName = found.name;
      }
    }
  }

  if ((!statusId || !statusName) && typeof statusName === "string") {
    const sName = statusName.trim().toLowerCase();
    const found = [
      { id: 1, name: "Pending" },
      { id: 2, name: "Completed" },
      { id: 3, name: "Missed" },
      { id: 4, name: "Canceled" },
      { id: 4, name: "Cancelled" },
      { id: 5, name: "ReScheduled" },
      { id: 5, name: "Rescheduled" },
      { id: 6, name: "Overdue" },
    ].find(s => s.name.toLowerCase() === sName);
    if (found) {
      statusId = found.id;
      statusName = found.name;
    }
  }

  return {
    id: statusId || 1,
    name: statusName || "Pending"
  };
};